<section class="flex flex-col w-full id-document">
  <div class="text-center flex flex-col gap-8 md:gap-10">
    <h1 class="outfit extra-bold heading-large">{{ idDocument.title | translate }}</h1>
    <p class="paragraph-medium font-normal outfit inline-block sub-text">
      <span>{{ idDocument.ssn | translate }}</span
      ><span class="font-bold">{{ idDocument.mexicanID | translate }}</span>
    </p>
  </div>
  <div class="mt-8 md:mt-10 mb-12">
    <nz-collapse [nzGhost]="true" [nzBordered]="false" [nzExpandIconPosition]="'end'" class="w-full">
      @for (panel of idDocument.panels; track panel) {
        <nz-collapse-panel
          [nzHeader]="headerTemplate"
          [(nzActive)]="panel.active"
          (nzActiveChange)="panelToggled.emit()"
        >
          <ng-template #headerTemplate>
            <div class="flex flex-col gap-2 justiy-start items-start">
              <span class="paragraph-medium outfit header font-bold">{{ panel.name | translate }}</span>
              <span class="paragraph-small-card outfit font-light sub-header">{{ panel.description | translate }}</span>
            </div>
          </ng-template>
          @if (panel.details && panel.details.length > 0) {
            <ul class="flex flex-col list-disc items-start">
              @for (item of panel.details; track item) {
                <li class="paragraph-medium list-disc font-medium outfit">{{ item | translate }}</li>
              }
            </ul>
          }
        </nz-collapse-panel>
      }
    </nz-collapse>
  </div>
  <p class="paragraph-medium text-center font-normal pb-6 sm:pb-8 outfit">{{ idDocument.remember | translate }}</p>
</section>
